import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import './VerwaltungOverview.css';

/**
 * VerwaltungOverview Component
 * Displays a dashboard with tiles for all management entities.
 */
const VerwaltungOverview = () => {
    const navigate = useNavigate();
    const { user, toolPermissions } = useAuth();

    const journalTool = toolPermissions.journal;
    const projectPerms = journalTool?.permissions || journalTool;
    const isGlobalAdmin = user?.role === 'admin';
    const hasGlobalProjectRights = isGlobalAdmin || projectPerms?.view_all_projects || projectPerms?.create_projects;


    const sections = [
        {
            id: 'mitarbeiter',
            title: 'Mitarbeiter',
            description: 'Personalstamm und Qualifikationen',
            icon: '🧑‍💼',
            path: '/verwaltung/mitarbeiter',
            color: '#34c759'
        },
        {
            id: 'fahrzeuge',
            title: 'Fuhrpark',
            description: 'Fahrzeuge, Termine und Fristen',
            icon: '🚗',
            path: '/verwaltung/fuhrpark',
            color: '#f093fb'
        },
        {
            id: 'projekte',
            title: 'Projekte',
            description: 'Bauvorhaben und Standorte',
            icon: '🏗️',
            path: '/verwaltung/projekte',
            color: '#4facfe'
        },
        {
            id: 'kunden',
            title: 'Kunden',
            description: 'Kundenstamm und Kontakte',
            icon: '🤝',
            path: '/verwaltung/kunden',
            color: '#fa709a'
        },
        {
            id: 'material',
            title: 'Material',
            description: 'Inventar (In Vorbereitung)',
            icon: '📦',
            path: '#',
            color: '#86868b',
            disabled: true
        }
    ].filter(section => {
        if (section.id === 'projekte') {
            return hasGlobalProjectRights;
        }
        return true;
    });

    return (
        <div className="verwaltung-overview">
            <div className="overview-grid">
                {sections.map(section => (
                    <div 
                        key={section.id} 
                        className={`overview-card ${section.disabled ? 'disabled' : ''}`}
                        onClick={() => !section.disabled && navigate(section.path)}
                        style={{ '--accent-color': section.color }}
                    >
                        <div className="card-icon">{section.icon}</div>
                        <div className="card-content">
                            <h3>{section.title}</h3>
                            <p>{section.description}</p>
                        </div>
                        {!section.disabled && <div className="card-arrow">→</div>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default VerwaltungOverview;
